import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const UserGroup_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.8274 14.4451C15.4925 15.0335 15.0933 15.5804 14.6392 16.0763C14.853 16.2682 15.0845 16.441 15.3308 16.5918C15.1441 16.67 14.9635 16.757 14.7891 16.8523C15.2986 17.2932 15.6795 17.8787 15.8681 18.5449C16.4199 18.2691 17.0638 18.1141 17.7976 18.1141C19.5421 18.1141 20.7788 18.99 21.4775 20.2837C21.7399 20.7697 22.3466 20.9509 22.8326 20.6884C23.3185 20.426 23.4997 19.8193 23.2373 19.3333C22.5821 18.1202 21.5722 17.1395 20.2645 16.5918C21.6223 15.7604 22.5283 14.2632 22.5283 12.5544C22.5283 9.94167 20.4103 7.82366 17.7976 7.82366C17.442 7.82366 17.0956 7.86289 16.7625 7.93726C16.9136 8.58162 16.9954 9.25265 16.9998 9.94206C17.2522 9.86508 17.5201 9.82366 17.7976 9.82366C19.3058 9.82366 20.5283 11.0462 20.5283 12.5544C20.5283 14.0625 19.3058 15.2851 17.7976 15.2851C17.0233 15.2851 16.3243 14.9628 15.8274 14.4451Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.36918 5.46338C5.8819 5.46338 3.86556 7.47972 3.86556 9.96701C3.86556 12.4543 5.8819 14.4706 8.36918 14.4706C10.8565 14.4706 12.8728 12.4543 12.8728 9.96701C12.8728 7.47972 10.8565 5.46338 8.36918 5.46338ZM1.86556 9.96701C1.86556 6.37515 4.77733 3.46338 8.36918 3.46338C11.961 3.46338 14.8728 6.37515 14.8728 9.96701C14.8728 12.7041 13.182 15.0463 10.7878 16.006C13.1233 16.6396 14.8924 18.1874 15.9757 20.1933C16.2382 20.6793 16.057 21.2859 15.571 21.5484C15.0851 21.8108 14.4784 21.6296 14.216 21.1437C13.1084 19.093 11.1299 17.6937 8.36918 17.6937C5.60844 17.6937 3.62996 19.093 2.52241 21.1437C2.25996 21.6296 1.65327 21.8108 1.16733 21.5484C0.681385 21.2859 0.500203 20.6793 0.762648 20.1933C1.84598 18.1874 3.61505 16.6396 5.95057 16.006C3.55641 15.0463 1.86556 12.7041 1.86556 9.96701Z"
            />
        </SvgStyled>
    );
};

export default UserGroup_md;
